import { useRef, useCallback } from 'react';

/**
 * Returns a function reference whose identity never changes across renders,
 * while always invoking the latest version of `callback`.
 *
 * Use this to pass event-handler props to a React.memo'd child without
 * having to correctly enumerate every closure dependency in a useCallback
 * array by hand -- the returned function can't defeat memo's shallow prop
 * comparison (its reference is stable), and it can't go stale either (it
 * always reads the current callback via a ref updated on every render).
 */
export function useStableCallback(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback((...args) => callbackRef.current(...args), []);
}

export default useStableCallback;
